import { render, staticRenderFns } from "./ManageNave.vue?vue&type=template&id=2c2cb72f&scoped=true"
import script from "./ManageNave.vue?vue&type=script&lang=js"
export * from "./ManageNave.vue?vue&type=script&lang=js"
import style0 from "./ManageNave.vue?vue&type=style&index=0&id=2c2cb72f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2cb72f",
  null
  
)

export default component.exports